import api from './api'
import eventBus from '@/utils/eventBus'

const API_URL = process.env.VUE_APP_API_URL || 'https://empirecanada.ca/api';
console.log('API_URL no projectService:', API_URL)

export const projectService = {
  /**
   * Fetches projects associated with a user by email
   * @param {string} email - User's email
   * @returns {Promise<Array>} - List of projects
   */
  async getProjectsByUserEmail(email) {
    console.log(`Iniciando chamada à API para buscar projetos do usuário: ${email}`)
    try {
      console.log(`URL da API: ${API_URL}/users/projects/by-email?email=${email}`)
      const response = await api.get(`${API_URL}/users/projects/by-email`, {
        params: { email }
      })
      console.log('Resposta da API de projetos:', response.data)
      return response.data
    } catch (error) {
      console.error('Erro ao buscar projetos do usuário:', error)
      console.error('Detalhes do erro:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status
      })
      throw error
    }
  },

  /**
   * Fetches projects of the logged-in user (using the JWT token)
   * @returns {Promise<Array>} - List of projects of the logged-in user
   */
  async getCurrentUserProjects() {
    console.log('Iniciando chamada à API para buscar projetos do usuário logado')
    try {
      const response = await api.get(`${API_URL}/users/projects/current`)
      console.log('Resposta da API de projetos do usuário logado:', response.data)
      return response.data
    } catch (error) {
      console.error('Erro ao buscar projetos do usuário logado:', error)
      console.error('Detalhes do erro:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status
      })
      throw error
    }
  },

  /**
   * Saves the selected project in sessionStorage
   * @param {Object} project - Project object
   */
  saveSelectedProject(project) {
    sessionStorage.setItem('selectedProject', JSON.stringify(project))
    // Emits a global event to notify all components
    eventBus.emit('selected-project-changed', project)
    console.log('Evento selected-project-changed emitido com:', project)
  },

  /**
   * Gets the selected project from sessionStorage
   * @returns {Object|null} - Project object or null if there is no selected project
   */
  getSelectedProject() {
    const projectData = sessionStorage.getItem('selectedProject')
    return projectData ? JSON.parse(projectData) : null
  },

  /**
   * Gets the delivery options available for the logged-in user
   * Rule (API): PickUp only if in the effective project (selected or single active one) client_id = master_client_id.
   * @param {string|null|undefined} projectId - UUID of the selected project (sessionStorage)
   * @returns {Promise<Object>} - { allowPickup: boolean, projectCount: number, hasDenonce: boolean, reason?: string }
   */
  async getDeliveryOptions(projectId = null) {
    console.log('Iniciando chamada à API para obter opções de entrega', projectId || '')
    try {
      const params = projectId ? { project_id: projectId } : {}
      const response = await api.get(`${API_URL}/users/delivery-options`, { params })
      console.log('Resposta da API de opções de entrega:', response.data)
      return response.data
    } catch (error) {
      console.error('Erro ao obter opções de entrega:', error)
      console.error('Detalhes do erro:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status
      })
      // In case of error, returns default options (allows pickup)
      return {
        allowPickup: true,
        projectCount: 0,
        hasDenonce: false,
        reason: 'Erro ao verificar opções de entrega'
      }
    }
  }
}
